import Resident from "./Resident";
export default Resident;
